import React from "react";
import { gnhUsersSubmittedFormList } from "./DrivingExemptionPageSelector";
import DrivingExemptionDashboard from "./DrivingExemptionDashboard";
import { GNHView } from "./DrivingExemptionView";


const DrivingExemptionUserList = () => {
    return (
        <DrivingExemptionDashboard
            page={gnhUsersSubmittedFormList}
            pageView={GNHView.MyForm}
        />
    );
}

export default DrivingExemptionUserList;

